import StoredLayout from '../../layouts/StoredLayout'
import AreaChartWidgets from './AreaChartWidgets'
export default StoredLayout(AreaChartWidgets)



// WEBPACK FOOTER //
// ./src/widgets/area-chart-widgets/index.js